import { Component, OnInit, Input } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  AbstractControl,
  FormControl,
  ValidatorFn,
  FormArray,
} from "@angular/forms";
import { Router, ActivatedRoute, provideRoutes } from "@angular/router";
import { WMS } from "src/app/classes/device";
import { DashboardService } from "../dashboard.service";
import { ToastrService } from "ngx-toastr";
import { DatePipe } from "@angular/common";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { MustMatch } from "src/app/data-service/must-match.validator";

@Component({
  selector: "app-add-mppt-string",
  templateUrl: "./add-mppt-string.component.html",
  styleUrls: ["./add-mppt-string.component.scss"],
})
export class AddMpptStringComponent implements OnInit {
  private ResponseVerifiedInverterList: Subject<any> = new Subject();
  @Input() type: String;
  @Input() makeId: any;
  inverterList: any = [];
  wmsInfo = new WMS();
  pipe = new DatePipe("en-US");
  addStringPopup: FormGroup;
  message: string;
  DeviceList: any;
  deviceId: any;
  role: any;
  roleName: string;
  mpptArray: any;
  stringArray: any;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private dashbord: DashboardService,
    private toastr: ToastrService
  ) {
    this.role = localStorage.role;
    if (this.role == "1") {
      this.roleName = "admin";
    } else if (this.role == "2") {
      this.roleName = "epc";
    }
  }
  ngOnInit() {
    this.addStringPopup = this.fb.group({
      strings: this.fb.array([]),
    });

    this.getMpptStringData();
  }
  get f() {
    return this.addStringPopup.controls;
  }

  createStrings(mppt, v = null, i = null, p = null): FormGroup {
    return this.fb.group({
      mppt: [mppt, Validators.required],
      v: [v, Validators.required],
      i: [i, Validators.required],
      p: [p, Validators.required],
    });
  }

  get strings(): FormArray {
    return <FormArray>this.addStringPopup.get("strings");
  }

  clearArrayForm() {
    this.strings.clear();
  }

  addString(mppt = null, v = null, i = null, p = null) {
    this.strings.push(this.createStrings(mppt, v, i, p));
  }

  addRow() {
    this.addString();
  }

  removeString(i) {
    this.strings.removeAt(i);
  }

  ngOnDestroy() {}
  changeTime(e) {}

  private getMpptStringData() {
    this.clearArrayForm();
    this.dashbord
      .getStringMpptTableData({ type: this.type, makeId: this.makeId })
      .subscribe(
        async (result) => {
          if (result.status) {
            if (result.resultObject && result.resultObject.length > 0) {
              result.resultObject.forEach((ele) => {
                this.addString(ele.mppt, ele.v, ele.i, ele.p);
              });
            }
          } else if (!result.status) {
          }
        },
        (err) => {
          return console.error(err);
        }
      );
  }

  saveNop() {
    const postJson = {
      makeId: this.makeId,
      type: this.type,
      data: this.addStringPopup.value.strings,
    };
    console.log("===submit", postJson);
    this.dashbord.addStringMpptTableData(postJson).subscribe(
      (result) => {
        if (result.status) {
          this.toastr.show("Data has been saved successfully!");
        } else if (!result.status) {
          this.toastr.show("Something went wrong!");
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }
}
